const initialState = {
  vehicleWiseCardCollection: [],
  dayWiseCardCollection: [],
  issueTicketOnCard: {},
  cardIssued: [],
  cardRecharged: [],
  cardCollectionSummary: { balanceLoaded: 0, walletUsage: 0, netPayout: 0 },
};
export default initialState;
